module.exports = __webpack_public_path__ + "static/HomePageSlide-20847e23cc498ff9d069bb076eacd467.png";